// @flow
import React, { useContext } from 'react';
import { useSubmitRecalcRequestForUserCommitMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import SPAsyncCalcContainer from '@components/common/pricing-summary-wrapper/SPAsyncCalcContainer';
import { TabsContainer } from '@presentational/TabsContainer';
import { IS_COMMIT_SFDC_VIEWS_LIVE } from '@streaming-projects/constants';
import { SPUserCommitPricingStatusContext } from '@streaming-projects/user-commit-details/contexts/SPUserCommitPricingStatusContext';
import { useLocation } from 'react-router-dom';
import { SPConnectTasksAlertContainer } from '@streaming-projects/user-commit-details/commit-summary/SPConnectTasksAlertContainer';
import { SPKafkaClustersAlertContainer } from '@streaming-projects/user-commit-details/commit-summary/SPKafkaClustersAlertContainer';
import { Spacer } from '@presentational/spacing/Spacer';

import { SPUserCommitMonthlySummaryContainer } from '../new-monthly-summary/SPUserCommitMonthlySummaryContainer';
import { SPUserCommitCustomViewsContainerWrapper } from '../custom-views/SPUserCommitCustomViewsContainerWrapper';
import { SPUserCommitSFDCFieldsViewsContainerWrapper } from '../sfdc-field-views/SPUserCommitSFDCFieldsViewsContainerWrapper';
import { useShouldPricingBeDisabled } from '../useShouldPricingBeEnabled';

const getInitialTabIndex = (urlSearchParams) => {
  const tabParam = urlSearchParams.get('tab');
  if (tabParam) {
    const tabIndex = parseInt(tabParam, 10);
    if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex <= 2) {
      return tabIndex;
    }
  }
  return 0;
};

export const SPUserCommitSummaryContainerWithTabs = () => {
  const { data } = useContext(SPUserCommitPricingStatusContext);
  const location = useLocation();
  const urlSearchParams = new URLSearchParams(location.search);
  const activeTabIndex = getInitialTabIndex(urlSearchParams);

  // Update URL when tab changes
  const updateURLWithTab = (tabIndex) => {
    const newSearchParams = new URLSearchParams(location.search);
    if (tabIndex === 0) {
      // Remove the tab parameter if it's the first tab (default)
      newSearchParams.delete('tab');
    } else {
      newSearchParams.set('tab', tabIndex.toString());
    }

    const newSearch = newSearchParams.toString();
    const newURL = newSearch ? `${location.pathname}?${newSearch}` : location.pathname;

    window.location.replace(newURL);
  };

  const handleTabChange = (activeIndex) => {
    updateURLWithTab(activeIndex);
  };

  const tabPanes = [
    {
      menuItem: 'Commit Monthly Spend',
      render: () => {
        return <SPUserCommitMonthlySummaryContainer />;
      },
    },
    {
      menuItem: 'Custom Views',
      render: () => <SPUserCommitCustomViewsContainerWrapper />,
    },
    ...(IS_COMMIT_SFDC_VIEWS_LIVE
      ? [
          {
            menuItem: 'SFDC Fields',
            render: () => <SPUserCommitSFDCFieldsViewsContainerWrapper />,
          },
        ]
      : []),
  ];
  const shouldPricingBeDisabled = useShouldPricingBeDisabled();

  return (
    <>
      <SPConnectTasksAlertContainer />
      <SPKafkaClustersAlertContainer />
      <Spacer y={1} />
      <SPAsyncCalcContainer
        data={data}
        disabled={shouldPricingBeDisabled}
        reloadAfterReclacRequest={true}
        useRecalcRequestMutation={useSubmitRecalcRequestForUserCommitMutation}
      >
        <TabsContainer
          callbackOnTabChange={handleTabChange}
          initialActiveIndex={activeTabIndex}
          tabPanes={tabPanes}
        />
      </SPAsyncCalcContainer>
    </>
  );
};
